import vTextarea from "./v-textarea.vue";

export default Vue => {
  Vue.component("v-textarea", vTextarea);
};
